import React from "react";
import { motion } from "framer-motion";
import { MapPin, CheckCircle2 } from "lucide-react";

const ZONES = [
  { name: "IFZA", city: "Dubai", tag: "Most flexible activities", hot: true },
  { name: "DMCC", city: "Dubai", tag: "Commodities & trading hub" },
  { name: "Meydan", city: "Dubai", tag: "Fast virtual licensing", hot: true },
  { name: "SHAMS", city: "Sharjah", tag: "Media & creative" },
  { name: "RAKEZ", city: "Ras Al Khaimah", tag: "Low-cost industrial" },
  { name: "DIFC", city: "Dubai", tag: "Financial services" },
  { name: "ADGM", city: "Abu Dhabi", tag: "Common-law fintech hub" },
  { name: "JAFZA", city: "Dubai", tag: "Logistics & warehousing" },
  { name: "DAFZA", city: "Dubai Airport", tag: "Aviation & trade" },
  { name: "Masdar", city: "Abu Dhabi", tag: "Cleantech & energy" },
  { name: "Fujairah Creative City", city: "Fujairah", tag: "Media & consultancy" },
  { name: "SRTIP", city: "Sharjah", tag: "R&D and innovation" },
];

export default function FreezonesGrid() {
  return (
    <section
      data-testid="freezones-section"
      className="relative bg-white py-20 md:py-32"
    >
      <div className="container-x">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-8 mb-12">
          <div className="max-w-2xl">
            <p className="overline text-[#3366FF]">Freezone network</p>
            <div className="gold-rule mt-5 mb-6" />
            <h2 className="font-heading font-light tracking-tight text-[#0F172A] text-3xl sm:text-4xl lg:text-5xl leading-tight">
              We set up in{" "}
              <span className="font-black text-[#002366]">45+ Freezones</span> across all
              7 Emirates.
            </h2>
          </div>
          <p className="md:max-w-sm text-slate-600 leading-relaxed">
            Every Freezone has its own cost structure, permitted activities and banking
            profile. We match yours in the first discovery call.
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-4">
          {ZONES.map((z, i) => (
            <motion.div
              key={z.name}
              data-testid={`freezone-${i}`}
              initial={{ opacity: 0, y: 16 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.4, delay: (i % 4) * 0.05 }}
              className="relative rounded-sm border border-slate-200 bg-white p-5 hover:border-[#3366FF]/50 hover:shadow-md transition-all group"
            >
              {z.hot && (
                <span className="absolute top-3 right-3 chip !text-[10px] !tracking-[0.12em]">
                  Popular
                </span>
              )}
              <div className="flex items-center gap-2 text-[#3366FF]">
                <MapPin className="w-4 h-4" />
                <span className="text-xs font-heading font-bold tracking-wider uppercase">
                  {z.city}
                </span>
              </div>
              <div className="mt-3 font-heading font-black tracking-tight text-[#0F172A] text-lg md:text-xl">
                {z.name}
              </div>
              <div className="mt-1 text-xs md:text-sm text-slate-600">{z.tag}</div>
              <div className="mt-4 flex items-center gap-1.5 text-xs text-slate-500 opacity-0 group-hover:opacity-100 transition-opacity">
                <CheckCircle2 className="w-3.5 h-3.5 text-[#3366FF]" />
                Available via StartINC
              </div>
            </motion.div>
          ))}
        </div>

        <div className="mt-10 text-sm text-slate-500">
          …plus JAFZA E-Commerce, SPC Freezone, Hamriyah, Ajman Free Zone, UAQ FTZ, KIZAD
          and 30+ others on request.
        </div>
      </div>
    </section>
  );
}
